import { createAction, props } from '@ngrx/store';

export const ERROR = createAction('ERROR handler', props<{ error: any }>());
